import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {BrowserStorageDataEnum} from '@services/browser-storage.service';
import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import {map} from 'rxjs/operators';
import {WorkingObjectListItem} from '../objects-list/working-object-list-item';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class WorkingObjectPagesService extends PagingApiService<WorkingObjectNamespace.ListItem> {
    protected baseUrl = 'working-object/pages';

    listItems$: Observable<WorkingObjectListItem[]> = this.items$.pipe(
        map(items => items.map(item => new WorkingObjectListItem(item)))
    );

    itemsPerPageCounts = [5, 10, 15];

    defaultItemsPerPage = 5;

    itemsPerPageStorageKey = BrowserStorageDataEnum.workingObjectsItemsPerPageCount;
}
